import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Image, Card } from 'react-bootstrap'

function SettingsMenu({unityContext}){


// Unity request functions
function requestLoadRoom(id){
    console.log(id)
    unityContext.send("LevelManager", "loadRoom", id); //currentRoomId ??? 
}



    return (
        <div style={{  height: 'calc(100vh - 4rem)', overflowY: "scroll", overflowX: "hidden" }} >
            
        
            <Card style={{ width: '260px', marginTop: '2px', marginLeft: '1px' }}>
            <Card.Body>
                <Card.Title>Description</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">XRevent Creator</Card.Subtitle>
                <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent Creator is intended to help users of the XRevent platform to build a virtual venue location.
                    Rooms built with this tool can be dynamically loaded by the client software. 
                </Card.Text>
                <p>
                    Download Demo Clients <br/>
                    <Card.Link href="../download/Quest/xrevent.apk">Occulus Quest</Card.Link>
                    <Card.Link href="../download/Win/XRevent_Win.zip">Win</Card.Link>
                    <Card.Link href="../download/Mac/AppMac.app.zip">Mac</Card.Link>
                </p>
                <p>
                    XRevent Browser Preview<br/>
                    <Card.Link href="../play">WebGL</Card.Link>
                </p>
                <Card.Text style={{fontSize: '10pt'}}>
                    We have prepared these six rooms for you to edit. Feel free to modify them.
                </Card.Text>
            </Card.Body>
            </Card>

            <Card style={{ width: '260px', marginTop: '4px', marginLeft: '1px'  }}>
                <Card.Img variant="top" src="/upload/0264419d-2397-4d51-a1ec-9dc065d6e6a3/preview.jpg" type="button" onClick={() => requestLoadRoom("0264419d-2397-4d51-a1ec-9dc065d6e6a3")}/>
                <Card.Body>
                    <Card.Title>Room A</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: 0264419d-2397-4d51-a1ec-9dc065d6e6a3
                    </Card.Text>
                    
                </Card.Body>
            </Card>

            <Card style={{ width: '260px', marginTop: '4px', marginLeft: '1px'  }}>
                <Card.Img variant="top" src="/upload/f71866b8-62f6-4414-a247-05c58497b477/preview.jpg" type="button" onClick={() => requestLoadRoom("f71866b8-62f6-4414-a247-05c58497b477")}/>
                <Card.Body>
                    <Card.Title>Room B</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: f71866b8-62f6-4414-a247-05c58497b477
                    </Card.Text>
                    
                </Card.Body>
            </Card>

            <Card style={{ width: '260px', marginTop: '4px', marginLeft: '1px'  }}> 
                <Card.Img variant="top" src="/upload/99b343e4-e5e2-4813-8250-3dcd4892508d/preview.jpg" type="button" onClick={() => requestLoadRoom("99b343e4-e5e2-4813-8250-3dcd4892508d")}/>
                <Card.Body>
                    <Card.Title>Room C</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: 99b343e4-e5e2-4813-8250-3dcd4892508d
                    </Card.Text>
                    
                </Card.Body>
            </Card>

            <Card style={{ width: '260px,', marginTop: '4px', marginLeft: '1px'  }}>
                <Card.Img variant="top" src="/upload/e2615bcc-3945-47ac-af04-5547807621e1/preview.jpg" type="button" onClick={() => requestLoadRoom("e2615bcc-3945-47ac-af04-5547807621e1")}/>
                <Card.Body>
                    <Card.Title>Room D</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: e2615bcc-3945-47ac-af04-5547807621e1
                    </Card.Text>
                    
                </Card.Body>
            </Card>

            <Card style={{ width: '260px', marginTop: '4px', marginLeft: '1px'  }}>
                <Card.Img variant="top" src="/upload/42c655a6-9c18-4f4c-8427-f2f7e16e1600/preview.jpg" type="button" onClick={() => requestLoadRoom("42c655a6-9c18-4f4c-8427-f2f7e16e1600")}/>
                <Card.Body>
                    <Card.Title>Room E</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: 42c655a6-9c18-4f4c-8427-f2f7e16e1600
                    </Card.Text>
                    
                </Card.Body>
            </Card>

            <Card style={{ width: '260px', marginTop: '4px', marginLeft: '1px'  }}>
                <Card.Img variant="top" src="/upload/20781727-6e9a-4a9a-9a3d-90ebad7c1281/preview.jpg" type="button" onClick={() => requestLoadRoom("20781727-6e9a-4a9a-9a3d-90ebad7c1281")} />
                <Card.Body>
                    <Card.Title>Room F</Card.Title>
                    <Card.Text style={{fontSize: '10pt'}}>
                    The XRevent ID for this room is: 20781727-6e9a-4a9a-9a3d-90ebad7c1281
                    </Card.Text>
                    
                </Card.Body>
            </Card>

        </div>
    )
}

export default SettingsMenu

